import { render, staticRenderFns } from "./OriginatorManagement.vue?vue&type=template&id=b69029da"
import script from "./OriginatorManagement.vue?vue&type=script&lang=js"
export * from "./OriginatorManagement.vue?vue&type=script&lang=js"
import style0 from "./OriginatorManagement.vue?vue&type=style&index=0&id=b69029da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports